import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
    UserPoolId : "eu-north-1_yDq0G491v",
    ClientId : "5f3s2ul9rqtbqgbf3ugheo9v6v",
}

export default new CognitoUserPool(poolData)